import type { AxiosError } from 'axios';
import type { TEditProfileBody } from 'src/types/user';

import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, DialogActions, Stack, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useEditProfileInfo, useGetUserInfo } from 'src/api/user';
import ProgressBar from 'src/components/progress-bar';
import { UserProfileEditBodySchema } from 'src/schema/user-schema';

// ----------------------------------------------------------------------

interface Props {
  open: boolean;
  onClose: VoidFunction;
  onSuccess: VoidFunction;
}

export default function ProfileQuickEditForm({
  onSuccess,
  open,
  onClose,
}: Props) {
  const { data: userInfoData } = useGetUserInfo({ enabled: false });
  const queryClient = useQueryClient();
  const { mutateAsync: editMutate, isPending: isPendingEdit } =
    useEditProfileInfo();
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm<TEditProfileBody>({
    mode: 'all',
    defaultValues: {
      //   email:userInfoData?.data.email,
      firstname: userInfoData?.data.firstname ?? '',
      lastname: userInfoData?.data.lastname ?? '',
    },
    resolver: zodResolver(UserProfileEditBodySchema),
  });

  const onSubmit = handleSubmit(
    async (
      data, // mobile and password and redirect url param need in next page
    ) => {
      await editMutate({
        body: { ...data },
      })
        .then(async res => {
          toast.success(res.message);
          await queryClient.invalidateQueries({ queryKey: ['user-info'] });
          onSuccess();
        })
        .catch((e: AxiosError<{ message: string | { email: string } }>) => {
          if (typeof e.response?.data.message === 'object') {
            toast.error(e.response.data.message.email);
          } else {
            toast.error(e.response?.data.message ?? e.message);
          }
        });
    },
  );
  return (
    <Dialog
      fullWidth
      maxWidth={false}
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: { maxWidth: 720 },
      }}
    >
      <DialogTitle>Edit Profile</DialogTitle>
      <DialogContent sx={{ py: 2 }}>
        <Box sx={{ p: 2 }}>
          <form noValidate onSubmit={onSubmit}>
            <Stack spacing={3}>
              <TextField
                fullWidth
                autoFocus
                error={!!errors.firstname?.message}
                {...register('firstname')}
                helperText={errors.firstname?.message}
                label="First Name"
                // onBlur={formik.handleBlur}
                // onChange={formik.handleChange}
                // type="email"
                // value={formik.values.email}
              />
              <TextField
                fullWidth
                helperText={errors.lastname?.message}
                label="Last Name"
                error={!!errors.lastname?.message}
                // name="password"
                // onBlur={formik.handleBlur}
                // onChange={formik.handleChange}
                {...register('lastname')}
                // value={formik.values.password}
              />
              {/* <TextField
                  error={!!errors.lastname?.message}
                  fullWidth
                  helperText={errors.lastname?.message}
                  label="Email"
                  // name="password"
                  // onBlur={formik.handleBlur}
                  // onChange={formik.handleChange}
                  type="email"
                  {...register("email")}
                  // value={formik.values.password}
                /> */}
            </Stack>
            {/* {errors.submit && (
                <FormHelperText error sx={{ mt: 3 }}>
                  {errors.submit as string}
                </FormHelperText>
              )} */}
            <DialogActions
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  onClose();
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={isPendingEdit}
                type="submit"
                variant="contained"
              >
                {isPendingEdit ? <ProgressBar /> : 'Submit'}
              </Button>
            </DialogActions>

            {/* <Box sx={{ mt: 3 }}>
                <Link href={paths.auth.forgetPassword} component={RouterLink} underline="hover" variant="subtitle2">
                  {t(tokens.login.ForgetPasswordQuestion)}
                </Link>
              </Box> */}
          </form>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
